import Lang from '/@/modules/core/app/services/Lang';

export class ClearEstateLink {
  static get SECURITY_COMPLIANCE(): string {
    return Lang.t('https://www.clearestate.com/security-compliance');
  }

  static get FR_SECURITY_COMPLIANCE(): string {
    return Lang.t('https://www.clearestate.com/fr-ca/securite-conformite');
  }

  static get ADVISOR_PRO_WEBSITE(): string {
    return Lang.t('https://www.clearestate.com/products/advisor-pro');
  }

  static get USA_PRICING_PLANS(): string {
    return Lang.t('https://www.clearestate.com/en-us/estate-settlement-solutions#pricing');
  }

  static get CANADA_EN_PRICING_PLANS(): string {
    return Lang.t(
      'https://www.clearestate.com/estate-settlement-solutions?__geom=%E2%9C%AA#pricing'
    );
  }

  static get CANADA_FR_PRICING_PLANS(): string {
    return Lang.t(
      'https://www.clearestate.com/fr-ca/services-de-reglement-de-succession?__geom=%E2%9C%AA#pricing'
    );
  }
}
